import React, {useState} from "react";

import { Box, Button, Column, Columns, Control, Field, File, Pagination, Tabs } from "@allxsmith/bestax-bulma";
import {useVehiclesData} from "../../../hooks/useVehiclesData";
import {
  getDataFresh, getDepartmentsData,
  getVehiclesData, getVehicleStatusCount,
} from "../../../state/selectors";
import Spinner from "react-spinner-material";
import {useDispatch, useSelector} from "react-redux";
import {onFileChange} from "../../../utils";
import ActiveHeadings from "./headings/ActiveHeadings";
import ActiveRow from "./rows/ActiveRow";
import OrderedRow from "./rows/OrderedRow";
import OrderedHeadings from "./headings/OrderedHeadings";
import ArrivingRow from "./rows/ArrivingRow";
import ArrivingHeadings from "./headings/ArrivingHeadings";
import SoldHeadings from "./headings/SoldHeadings";
import SoldRow from "./rows/SoldRow";
import ForSaleRow from "./rows/ForSaleRow";
import ForSaleHeadings from "./headings/ForSaleHeadings";
import {
  createSetDataFreshAction,
  createSetVehiclesDataAction
} from "../../../actions/dataActions";
import {useVehicleStatusCountData} from "../../../hooks/useVehicleStatusCountData";
import StatusCount from "./StatusCount";
import SearchBar from "../../Utils/SearchBar";
import HireReadyHeadings from "./headings/HireReadyHeadings";
import HireReadyRow from "./rows/HireReadyRow";
import ProcessingSaleHeadings from "./headings/ProcessingSaleHeadings";
import ProcessingSaleRow from "./rows/ProcessingSaleRow";
import axios from "axios";
import {ToastContainer, toast} from "react-toastify";
import {useCapTotalChangesData} from "../../../hooks/useCapTotalChangesData";
import CapTotals from "./CapTotals";
import useSelect from "../../../hooks/useSelect";
import {useDepartmentsData} from "../../../hooks/useDepartmentsData";
import DepartmentPicker from "../../Job/DepartmentPicker";
import WorkshopHeading from "./headings/WorkshopHeadings";
import WorkshopRow from "./rows/WorkshopRow";
import SalesPrepHeadings from "./headings/SalesPrepHeadings";
import SalesPrepRow from "./rows/SalesPrepRow";
import NotSoldHeadings from "./headings/NotSoldHeadings";
import NotSoldRow from "./rows/NotSoldRow";
import SalesStockHeadings from "./headings/SalesStockHeadings";
import SalesStockRow from "./rows/SalesStockRow";
import Nav from "../../Nav/Nav";
import PaginationWrapper from "../../Utils/PaginationWrapper";
import useInput from "../../../hooks/useInput";

function VehiclesView({history, endpoint}) {
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [vehicleStatus, setVehicleStatus] = useState("ACTIVE");
  const [searchText, setSearchText] = useState();
  const [filters, setFilters] = useState({});
  const [currentSearch, setCurrentSearch] = useState();
  const [activeTab, setTab] = useState("fleet");
  const [searchFresh, setSearchFresh] = useState(0);
  const [fileList, setFileList] = useState();
  const [selectedDepartment, setSelectedDepartment] = useState();

  const [startDate, startDateInput] = useInput({
    type: "date",
    label: "Sold Start Date",
    initialValue: null,
  });


  const [endDate, endDateInput] = useInput({
    type: "date",
    label: "Sold Start Date",
    initialValue: null,
  });

  const purchaseTypeOptions = [
    {name: "All", value: "ALL"},
    {name: "None", value:"NONE"},
    {name: "Hire Agreement", value:"HIRE_AGREEMENT"},
    {name: "Fixed Rate", value:"REGULAR"},
    {name: "Lease Agreement", value:"LEASE_AGREEMENT"},
    {name: "Variable Rate", value:"FIXED_MONTHLY_CAPITAL"},
    {name: "Stocking Plan", value:"STOCKING_PLAN"}
  ];

  const [purchaseType, purchaseTypeInput, setPurchaseType] = useSelect({
    label: "Purchase Type",
    initialValue: purchaseTypeOptions[0].value,
    options: purchaseTypeOptions
  })


  const onFileSend = () => {
    if(fileList){
      const conf = {
        url: endpoint+"vehiclescap",
        method: "post",
        data: fileList[0]
      }
      axios(conf).then((res) => {
        dispatch(createSetDataFreshAction(dataFresh + 1));
        setFileList(undefined)
      }).catch(err => {
        toast.error("There was an error uploading the cap data", {position: "top-right"});
      })
    }
    else {
      toast.warning("No File was selected for upload", {position: "top-right"});
    }
  }



  let params = {page};
  if(startDate){
    params.sold_start_date = startDate
  }
  if(endDate){
    params.sold_end_date = endDate
  }
  if(purchaseType){
    params.purchaseType=purchaseType;
  }
  if(selectedDepartment){
    params.department_fin=selectedDepartment;
  }
  if (currentSearch) {
    params.search = currentSearch;
  }
  if (searchFresh) {
    params.searchFresh = searchFresh
  }
  if (activeTab === 'fleet') {
    params.tab = 'fleet';
    if (vehicleStatus !== 'all' && vehicleStatus !== "WORKSHOP" && vehicleStatus !== "SALES_PREP" && vehicleStatus !== "NOT_SOLD" && vehicleStatus !== "HIREREADY" && vehicleStatus !== "FORSALE") {
      params.vehicle_status = vehicleStatus;
    }
    if(vehicleStatus === "NOT_SOLD"){
        params.view = "NOT_SOLD"
    }
    if (vehicleStatus === 'ARRIVING') {
      params.vehicle_status = 'ORDERED';
      params.delivery_date_confirmed = true;
      params.order = 'delivery_date'
    }
    if (vehicleStatus === 'ORDERED') {
      params.order = 'month_due'
    }
    if (vehicleStatus === "WORKSHOP"){
        params.view = "WORKSHOP"
    }
    if (vehicleStatus === 'HIREREADY') {
      //params.vehicle_status = 'ACTIVE'
      params.view = 'HIREREADY'
    }
    if (vehicleStatus === "SALES_PREP"){
        params.view = "SALES_PREP"
    }
    if (vehicleStatus === "FORSALE"){
      params.view = "FORSALE"
    }
  } else {
    params.tab = 'customer'
  }

  for (let filter in filters) {
    if (filters[filter][0] && filters[filter][0][filter]) {
      params[filter] = filters[filter][0][filter];
    }
  }

  const onVehicleUpdate = (index, newVehicle) => {
    let newResults = [...data.results];
    let newState = { ...data, results: newResults };
    newState.results[index] = newVehicle;
    dispatch(createSetVehiclesDataAction(newState));
  };

  const onFinanceUpdate = (index, finance) => {
  }

  const onRowChange = (e, index, vehicle) => {
    let newVehicle = {...vehicle, [e.target.name]: e.target.value}
    onVehicleUpdate(index, newVehicle);
  }

  const onRowSave = (vehicle) => {
    const conf = {
      url: endpoint+"listvehicles/"+vehicle.id,
      method: "put",
      data: vehicle
    }
    axios(conf).then(() => {
      dispatch(createSetDataFreshAction(dataFresh + 1))
    })
  }

  let dataFresh = useSelector(getDataFresh);
  const complete = useVehiclesData(params, dataFresh);
  const countLoaded = useVehicleStatusCountData({}, dataFresh);
  const departmentsLoaded = useDepartmentsData({}, dataFresh);

  const capLoaded = useCapTotalChangesData({cap_dif: false}, dataFresh);


  const data = useSelector(getVehiclesData);
  const departments = useSelector(getDepartmentsData);
  const countData = useSelector(getVehicleStatusCount);

  const handleSearch = () => {
    setPage(1);
    setCurrentSearch(searchText);
    setSearchFresh(searchFresh+1);
  };

  const setNewVehicleStatus = (status) => {
    setPage(1)
    setVehicleStatus(status)
  }

  const clear = () => {
    setSearchText("");
    setCurrentSearch("");
    setPage(1);
  };

  const onDepartmentChange = e => {
    setSelectedDepartment(e.target.value);
  }

  if (!complete || !countLoaded || !departmentsLoaded) {
    return (
        <div>
          <Nav/>
          <Box>
            <Spinner
              className="spinner-centre"
              size={120}
              spinnerColor={"#3273dc"}
              spinnerWidth={2}
            />
          </Box>
        </div>
    );
  }

  document.title = "Vehicles";

  // TODO(bestax-migrate): `showFirstLast` — no showFirstLast prop in bestax Pagination
  return (
    <div>
      <Nav/>
      <br/>
      <br/>
      <Box>
        <Columns isMultiline>
          <Column>
            <label className="label">Search for a Vehicle</label>
            <SearchBar
              handleSearch={handleSearch}
              clear={clear}
              setSearchText={setSearchText}
              searchText={searchText}
            />
          </Column>
          <Column>
            <Field>
              <Control>
                <Button
                  onClick={() => window.open("/editvehicle", "_self")}
                  color="success"
                  className="is-pulled-right"
                >
                  New Vehicle +
                </Button>
              </Control>
            </Field>
          </Column>
        </Columns>
        <Columns isMultiline>
          <Column>
            <label className="label">Cap Upload</label>
            <Field className={"has-addons"}>
              <Control>
                <File
                  onChange={ e => onFileChange(e, fileList, setFileList)}
                />
              </Control>
              <Control>
                <Button
                  color={"success"}
                  onClick={onFileSend}
                  disabled={!(!!fileList)}
                >
                  Upload
                </Button>
              </Control>
            </Field>
          </Column>
          <Column>
            <DepartmentPicker
              selectedDepartment={selectedDepartment}
              departments={departments}
              onDepartmentChange={onDepartmentChange}
            />
          </Column>
          {purchaseTypeInput}
        </Columns>
      </Box>
      {capLoaded && <CapTotals />}
      <br/>
      <StatusCount data={countData}/>
      <Box>
        <h1 className="title">Vehicles</h1>
        <Tabs fullwidth align="centered" boxed>
          <Tabs.List>
            <Tabs.Item active={activeTab === "fleet"}><a onClick={() => {setTab("fleet"); setNewVehicleStatus('all');}}>Fleet
                        </a></Tabs.Item>
            <Tabs.Item active={activeTab === "customer"}><a onClick={() => {setTab("customer"); setNewVehicleStatus('all');}}>External Customer Vehicles
                        </a></Tabs.Item>
          </Tabs.List>
        </Tabs>
        {activeTab != "customer" &&
        <div>
          {vehicleStatus === "SOLD" &&
          <Columns>
            {startDateInput}
            {endDateInput}
          </Columns>
          }
        <Tabs align="centered" toggle>
          <Tabs.List>
            <Tabs.Item active={vehicleStatus === "EQUIPMENT"}><a onClick={() => setNewVehicleStatus("EQUIPMENT")}>Equipment
                        </a></Tabs.Item>
            <Tabs.Item active={vehicleStatus === "all"}><a onClick={() => setNewVehicleStatus("all")}>All
                        </a></Tabs.Item>
            <Tabs.Item active={vehicleStatus === "NOT_SOLD"}><a onClick={() => setNewVehicleStatus("NOT_SOLD")}>All (Not Sold)
                        </a></Tabs.Item>
            <Tabs.Item active={vehicleStatus === "ORDERED"}><a onClick={() => setNewVehicleStatus("ORDERED")}>Ordered
                        </a></Tabs.Item>
            <Tabs.Item active={vehicleStatus === "ARRIVING"}><a onClick={() => setNewVehicleStatus("ARRIVING")}>Arriving
                        </a></Tabs.Item>
            <Tabs.Item active={vehicleStatus === "ACTIVE"}><a onClick={() => setNewVehicleStatus("ACTIVE")}>Active
                        </a></Tabs.Item>
            <Tabs.Item active={vehicleStatus === "WORKSHOP"}><a onClick={() => setNewVehicleStatus("WORKSHOP")}>Workshop
                        </a></Tabs.Item>
            <Tabs.Item active={vehicleStatus === "HIREREADY"}><a onClick={() => setNewVehicleStatus("HIREREADY")}>Hire Ready
                        </a></Tabs.Item>
            <Tabs.Item active={vehicleStatus === "SALES_STOCK"}><a onClick={() => setNewVehicleStatus("SALES_STOCK")}>Sales Stock
                        </a></Tabs.Item>
            <Tabs.Item active={vehicleStatus === "SALES_PREP"}><a onClick={() => setNewVehicleStatus("SALES_PREP")}>Sales Prep
                        </a></Tabs.Item>
            <Tabs.Item active={vehicleStatus === "FORSALE"}><a onClick={() => setNewVehicleStatus("FORSALE")}>For Sale
                        </a></Tabs.Item>
            <Tabs.Item active={vehicleStatus === "PENDING_SALE"}><a onClick={() => setNewVehicleStatus("PENDING_SALE")}>Pending Sale
                        </a></Tabs.Item>
            <Tabs.Item active={vehicleStatus === "PROCESSING"}><a onClick={() => setNewVehicleStatus("PROCESSING")}>Processing Sale
                        </a></Tabs.Item>
            <Tabs.Item active={vehicleStatus === "SOLD"}><a onClick={() => setNewVehicleStatus("SOLD")}>Sold
                        </a></Tabs.Item>
          </Tabs.List>
        </Tabs>
        </div>
        }
        <table className="table is-hoverable is-fullwidth is-striped">
          <thead>
          {(vehicleStatus === 'ACTIVE' || vehicleStatus === 'all' || vehicleStatus === "EQUIPMENT") && (
            <ActiveHeadings data={data} vehicleStatus={vehicleStatus} activeTab={activeTab} filters={filters} setFilters={setFilters} setPage={setPage}/>
          )}
          {(vehicleStatus === "NOT_SOLD") && (
              <NotSoldHeadings data={data} vehicleStatus={vehicleStatus} activeTab={activeTab} filters={filters} setFilters={setFilters} setPage={setPage}/>
          )}
          {(vehicleStatus === "WORKSHOP") && (
              <WorkshopHeading data={data} vehicleStatus={vehicleStatus} activeTab={activeTab} filters={filters} setFilters={setFilters} setPage={setPage}/>
          )}
          {(vehicleStatus === 'HIREREADY') && (
            <HireReadyHeadings data={data} vehicleStatus={vehicleStatus} activeTab={activeTab} filters={filters} setFilters={setFilters} setPage={setPage}/>
          )}
          {vehicleStatus === 'ORDERED' &&
            <OrderedHeadings data={data} vehicleStatus={vehicleStatus} activeTab={activeTab} filters={filters} setFilters={setFilters} setPage={setPage}/>
          }
          {vehicleStatus === 'ARRIVING' &&
            <ArrivingHeadings data={data} vehicleStatus={vehicleStatus} activeTab={activeTab} filters={filters} setFilters={setFilters} setPage={setPage}/>
          }
          {vehicleStatus === "SALES_STOCK" &&
            <SalesStockHeadings data={data} vehicleStatus={vehicleStatus} activeTab={activeTab} filters={filters} setFilters={setFilters} setPage={setPage}/>
          }
          {vehicleStatus === 'SALES_PREP' &&
            <SalesPrepHeadings data={data} vehicleStatus={vehicleStatus} activeTab={activeTab} filters={filters} setFilters={setFilters} setPage={setPage}/>
          }
          {(vehicleStatus === 'FORSALE' || vehicleStatus === "PENDING_SALE") && (
            <ForSaleHeadings data={data} vehicleStatus={vehicleStatus} activeTab={activeTab} filters={filters} setFilters={setFilters} setPage={setPage}/>
          )}
          {vehicleStatus === 'PROCESSING' &&
            <ProcessingSaleHeadings data={data} vehicleStatus={vehicleStatus} activeTab={activeTab} filters={filters} setFilters={setFilters} setPage={setPage}/>
          }
          {vehicleStatus === 'SOLD' &&
            <SoldHeadings data={data} vehicleStatus={vehicleStatus} activeTab={activeTab} filters={filters} setFilters={setFilters} setPage={setPage}/>
          }
          </thead>
          <tbody>
          {data.results.map((value, index) => {
              let finance;
              if (value.finance_agreements.length) {
                const agreements = value.finance_agreements.sort((a,b) => new Date(a.start_date) - new Date(b.start_date))
                finance = agreements[0]
              } else {
                finance = {
                  estimated_value: 0,
                  remaining_balance: 0,
                  sold_price: 0,
                  sold_date: "",
                  sale_comments: ""
                }
              }
              if (vehicleStatus === 'ACTIVE' || vehicleStatus === 'all' || vehicleStatus === "EQUIPMENT") {
                return <ActiveRow value={value} finance={finance} activeTab={activeTab}/>
              }
              if(vehicleStatus === "NOT_SOLD"){
                  return <NotSoldRow value={value} finance={finance} activeTab={activeTab}/>
              }
              if(vehicleStatus === "WORKSHOP"){
                  return <WorkshopRow value={value} finance={finance} activeTab={activeTab}/>
              }
              if (vehicleStatus === 'HIREREADY') {
                return <HireReadyRow value={value} finance={finance} activeTab={activeTab} dataFresh={dataFresh} onChange={onVehicleUpdate} index={index} onSave={onRowSave}/>
              }
              if (vehicleStatus === 'ORDERED') {
                return <OrderedRow index={index} onVehicleUpdate={onVehicleUpdate} endpoint={endpoint} value={value} finance={finance} activeTab={activeTab}/>
              }
              if (vehicleStatus === 'ARRIVING') {
                return <ArrivingRow index={index} onVehicleUpdate={onVehicleUpdate} endpoint={endpoint} value={value} finance={finance} activeTab={activeTab}/>
              }
              if (vehicleStatus === "SALES_STOCK"){
                return <SalesStockRow index={index} value={value} finance={finance} activeTab={activeTab} onSave={onRowSave} onChange={onRowChange}/>
              }
              if (vehicleStatus === 'SALES_PREP') {
                return <SalesPrepRow index={index} value={value} finance={finance} activeTab={activeTab} onSave={onRowSave} onChange={onRowChange}/>
              }
              if (vehicleStatus === 'FORSALE' || vehicleStatus === "PENDING_SALE") {
                return <ForSaleRow index={index} value={value} finance={finance} activeTab={activeTab} onSave={onRowSave} onChange={onRowChange}/>
              }
              if (vehicleStatus === 'PROCESSING') {
                return <ProcessingSaleRow value={value} finance={finance} activeTab={activeTab}/>
              }
              if (vehicleStatus === 'SOLD') {
                return <SoldRow value={value} finance={finance} activeTab={activeTab}/>

              }
            }

            )
          }
          </tbody>
        </table>
        <PaginationWrapper
          page={page}
          setPage={setPage}
          dataCount={Math.ceil(data.count / 25)}
        />
      </Box>
    </div>
  );
}

export default VehiclesView;
